import React from 'react'
import Logo from "./../../../Images/Logo.png";
import { Container, Row, Col } from "react-bootstrap";
// import useScript from 'hooks/useScript';
import { Helmet } from "react-helmet";

function LandingHeader() {

    return (
        <>
            <Helmet>
                <script
                    src='//in.fw-cdn.com/30289592/167137.js'
                    chat='false'>
                </script>
            </Helmet>
            {/* <section className="landing_header">
                    <div className="container">
                        <div className="landingheader_main">
                            <div className="row align-items-center">
                                <div className="col-sm-6">
                                    <div className="landingheader_logo">
                                        <a href="#"> <img className="img-fluid" src={Logo} alt="Logo" /></a>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="landingheader_text text-right">
                                        <a href="tel:91 9638237000" className="btn callus_header">Call US: 96382-37000</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
        </>
    )
}

export default LandingHeader